(function () {
  const root = document.querySelector("[data-media-database]");
  const payloadNode = document.querySelector("[data-media-database-payload]");

  if (!root || !payloadNode) return;

  const state = {
    products: [],
    filteredProducts: [],
  };

  const elements = {
    searchInput: root.querySelector("[data-search-input]"),
    typeFilter: root.querySelector("[data-type-filter]"),
    vendorFilter: root.querySelector("[data-vendor-filter]"),
    resetFilters: root.querySelector("[data-reset-filters]"),
    productCount: root.querySelector("[data-product-count]"),
    imageCount: root.querySelector("[data-image-count]"),
    certificateCount: root.querySelector("[data-certificate-count]"),
    resultsTitle: root.querySelector("[data-results-title]"),
    resultsSummary: root.querySelector("[data-results-summary]"),
    resultsGrid: root.querySelector("[data-results-grid]"),
    emptyState: root.querySelector("[data-empty-state]"),
    errorState: root.querySelector("[data-error-state]"),
    productTemplate: root.querySelector("[data-product-template]"),
  };

  function loadProducts() {
    let payload;

    try {
      payload = JSON.parse(payloadNode.textContent);
    } catch (error) {
      throw new Error("The Liquid JSON payload could not be parsed.");
    }

    return {
      sectionId: payload.sectionId || "",
      products: payload.products || [],
      collectionHandle: payload.collectionHandle || "",
      recordCount: payload.recordCount || 0,
      currentPage: payload.currentPage || 1,
      pageSize: payload.pageSize || payload.products?.length || 250,
    };
  }

  async function loadMoreProducts(payload) {
    if (!payload.sectionId || !payload.recordCount || payload.products.length >= payload.recordCount) {
      return payload.products;
    }

    const totalPages = Math.ceil(payload.recordCount / payload.pageSize);
    const allProducts = [...payload.products];

    for (let page = payload.currentPage + 1; page <= totalPages; page += 1) {
      const url = new URL(window.location.href);
      url.searchParams.set("section_id", payload.sectionId);
      url.searchParams.set("page", String(page));

      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
        },
      });

      if (!response.ok) break;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const extraPayloadNode = doc.querySelector("[data-media-database-payload]");

      if (!extraPayloadNode) break;

      const extraPayload = JSON.parse(extraPayloadNode.textContent);
      const extraProducts = extraPayload.products || [];

      if (!extraProducts.length) break;

      allProducts.push(...extraProducts);
    }

    return allProducts;
  }

  function addOptions(select, values) {
    values.forEach((value) => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      select.append(option);
    });
  }

  function populateFilters(products) {
    const types = [...new Set(products.map((product) => product.productType).filter(Boolean))].sort();
    const vendors = [...new Set(products.map((product) => product.vendor).filter(Boolean))].sort();

    addOptions(elements.typeFilter, types);
    addOptions(elements.vendorFilter, vendors);
  }

  function normalise(value) {
    return (value || "").toString().toLowerCase();
  }

  function applyFilters() {
    const searchTerm = normalise(elements.searchInput.value.trim());
    const selectedType = elements.typeFilter.value;
    const selectedVendor = elements.vendorFilter.value;

    state.filteredProducts = state.products.filter((product) => {
      const matchesType = !selectedType || product.productType === selectedType;
      const matchesVendor = !selectedVendor || product.vendor === selectedVendor;
      const searchBlob = [
        product.title,
        product.vendor,
        product.productType,
        product.metafields.sku,
        product.metafields.barcode,
        product.metafields.asin,
        product.metafields.hsCode,
        product.metafields.srp,
      ].map(normalise).join(" ");

      const matchesSearch = !searchTerm || searchBlob.includes(searchTerm);
      return matchesType && matchesVendor && matchesSearch;
    });

    renderResults();
  }

  function renderLinkList(container, items, variant) {
    container.innerHTML = "";

    if (!items.length) {
      container.textContent = "No files available";
      return;
    }

    items.forEach((item) => {
      const link = document.createElement("a");
      link.className = `media-db__download-chip media-db__download-chip--${variant}`;
      link.href = item.url;
      link.textContent = variant === "image" ? "" : item.label;
      link.target = "_blank";
      link.rel = "noreferrer";
      link.setAttribute("download", "");
      if (variant === "image") {
        const thumb = document.createElement("img");
        thumb.className = "media-db__thumb";
        thumb.src = item.url;
        thumb.alt = item.label;
        link.append(thumb);
      }
      container.append(link);
    });
  }

  function downloadAllImages(product) {
    product.images.forEach((item, index) => {
      window.setTimeout(() => {
        const link = document.createElement("a");
        link.href = item.url;
        link.download = "";
        link.rel = "noreferrer";
        document.body.append(link);
        link.click();
        link.remove();
      }, index * 120);
    });
  }

  function renderResults() {
    elements.resultsGrid.innerHTML = "";

    const imageTotal = state.filteredProducts.reduce((sum, product) => sum + product.images.length, 0);
    const certificateTotal = state.filteredProducts.reduce((sum, product) => sum + product.certificates.length, 0);

    elements.productCount.textContent = String(state.filteredProducts.length);
    elements.imageCount.textContent = String(imageTotal);
    elements.certificateCount.textContent = String(certificateTotal);
    elements.resultsTitle.textContent = `${state.filteredProducts.length} Product${state.filteredProducts.length === 1 ? "" : "s"} Found`;
    elements.resultsSummary.textContent = "Search by SKU, title, product type, or vendor and download available assets.";

    if (!state.filteredProducts.length) {
      elements.emptyState.classList.remove("hidden");
      return;
    }

    elements.emptyState.classList.add("hidden");

    const fragment = document.createDocumentFragment();

    state.filteredProducts.forEach((product) => {
      const node = elements.productTemplate.content.firstElementChild.cloneNode(true);
      const image = node.querySelector(".media-db__image");

      image.src = product.featuredImage.url || "";
      image.alt = product.featuredImage.alt || product.title;

      node.querySelector(".media-db__vendor").textContent = product.vendor || "";
      node.querySelector(".media-db__title").textContent = product.title || "";
      node.querySelector(".media-db__type").textContent = product.productType || "Product";
      node.querySelector(".media-db__meta-sku").textContent = product.metafields.sku || "N/A";
      node.querySelector(".media-db__meta-barcode").textContent = product.metafields.barcode || "N/A";
      node.querySelector(".media-db__meta-asin").textContent = product.metafields.asin || "N/A";
      node.querySelector(".media-db__meta-box-qty").textContent = product.metafields.boxQty || "N/A";
      node.querySelector(".media-db__meta-hs-code").textContent = product.metafields.hsCode || "N/A";
      node.querySelector(".media-db__meta-srp").textContent = product.metafields.srp || "N/A";

      renderLinkList(node.querySelector("[data-images-list]"), product.images, "image");
      renderLinkList(node.querySelector("[data-certificates-list]"), product.certificates, "certificate");
      const downloadAllButton = node.querySelector("[data-download-all-images]");
      if (!product.images.length) {
        downloadAllButton.disabled = true;
      } else {
        downloadAllButton.addEventListener("click", () => downloadAllImages(product));
      }
      fragment.append(node);
    });

    elements.resultsGrid.append(fragment);
  }

  function resetFilters() {
    elements.searchInput.value = "";
    elements.typeFilter.value = "";
    elements.vendorFilter.value = "";
    applyFilters();
  }

  function bindEvents() {
    elements.searchInput.addEventListener("input", applyFilters);
    elements.typeFilter.addEventListener("change", applyFilters);
    elements.vendorFilter.addEventListener("change", applyFilters);
    elements.resetFilters.addEventListener("click", resetFilters);
  }

  async function init() {
    try {
      const payload = loadProducts();
      state.products = await loadMoreProducts(payload);
      state.filteredProducts = state.products;
      populateFilters(state.products);
      bindEvents();
      renderResults();

      if (!payload.collectionHandle) {
        elements.errorState.textContent = "Add the collection handle in the section settings before using this page.";
        elements.errorState.classList.remove("hidden");
      } else if (!payload.products.length) {
        elements.errorState.textContent = `No products were found in the "${payload.collectionHandle}" collection.`;
        elements.errorState.classList.remove("hidden");
      } else if (payload.recordCount > state.products.length) {
        elements.errorState.textContent = `The page loaded ${state.products.length} of ${payload.recordCount} products. Shopify theme pagination is still limiting the full feed, so we may need a different loading strategy if any are missing.`;
        elements.errorState.classList.remove("hidden");
      }
    } catch (error) {
      elements.errorState.textContent = error.message || "Media database payload is missing or invalid.";
      elements.errorState.classList.remove("hidden");
      elements.resultsTitle.textContent = "Unable to load products";
      elements.resultsSummary.textContent = "Check the collection handle and the Liquid payload in the section.";
    }
  }

  init();
})();